import { motion } from "framer-motion";

const PHOTOS = [
  { src: "/team-remo.jpg", pos: "50% 50%" },
  { src: "/team-joe.jpg", pos: "50% 50%" },
];

export const Team = ({ t }) => {
  return (
    <section id="team" data-testid="team-section" className="section-pad bg-[#08080a] scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <p data-testid="team-overline" className="font-mono-accent text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">
            {t.team.overline}
          </p>
          <h2 data-testid="team-title" className="font-display font-bold text-4xl md:text-5xl text-white tracking-tight">
            {t.team.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base md:text-lg text-neutral-400">{t.team.sub}</p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl" data-testid="team-grid">
          {t.team.members.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
              data-testid={`team-member-${i}`}
              className="group"
            >
              <div className="relative overflow-hidden aspect-[3/4] border border-white/10">
                <img
                  src={PHOTOS[i].src}
                  alt={m.name}
                  style={{ objectPosition: PHOTOS[i].pos }}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#08080a]/90 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-pink-brand">{m.role}</p>
                  <h3 className="mt-1 font-display text-2xl font-semibold text-white">{m.name}</h3>
                </div>
              </div>
              <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{m.bio}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
